import Paper from '@mui/material/Paper';
import { blue } from '../../../theme/colors';
import { styled } from '@mui/material/styles';
import { StandardLonghandProperties } from 'csstype';

export const AccordionContainer = styled(Paper, {
  skipSx: false,
  shouldForwardProp: (prop) => prop !== 'backgroundColor',
})<{
  backgroundColor?: StandardLonghandProperties['backgroundColor'];
}>(
  ({ backgroundColor = blue[50] }) => `
  &.MuiPaper-root {
    background-color: ${backgroundColor};
  }`,
);
